let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8HFey"), load("7ylp3"), load("kIPUL"), load("emd3r"), load("4CNxJ")]).then(() => parcelRequire('2x2RL'));